import { createFileRoute, Link } from "@tanstack/react-router";
import { MarketingShell } from "@/components/marketing-shell";
import { Button } from "@/components/ui/button";
import { redirectIfAuthenticated } from "@/lib/marketing-guards";

export const Route = createFileRoute("/about")({
  beforeLoad: redirectIfAuthenticated,
  head: () => ({
    meta: [
      { title: "About, Super Affiliate OS" },
      {
        name: "description",
        content:
          "Super Affiliate OS is built by affiliate marketers, for affiliate marketers. Learn the story and the philosophy behind the product.",
      },
      { property: "og:title", content: "About, Super Affiliate OS" },
      {
        property: "og:description",
        content: "Built by affiliate marketers, for affiliate marketers.",
      },
    ],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <MarketingShell>
      <article className="mx-auto max-w-3xl px-6 py-20">
        <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">About Super Affiliate OS</h1>
        <p className="mt-6 text-lg text-muted-foreground">
          Affiliate marketing runs on spreadsheets, screenshots, and Slack threads. We've lived it
         , chasing payouts, reconciling reports from a dozen networks, and trying to remember
          which AM owes us what. Super Affiliate OS exists to end that.
        </p>

        <h2 className="mt-12 text-2xl font-semibold tracking-tight">Our philosophy</h2>
        <p className="mt-3 text-muted-foreground">
          One workspace. One source of truth. Strong opinions about where data lives, how teams
          collaborate, and what an affiliate operation actually needs to scale. We'd rather build
          fewer features that go all the way than a long list of half-finished ones.
        </p>

        <h2 className="mt-12 text-2xl font-semibold tracking-tight">What we believe</h2>
        <ul className="mt-3 space-y-3 text-muted-foreground">
          <li>
            <strong className="text-foreground">Anomalies first.</strong> The fastest path to more
            revenue is catching what's quietly going wrong.
          </li>
          <li>
            <strong className="text-foreground">Contacts are the graph.</strong> Every campaign,
            payout, and conversation ladders back to a person. Treat them that way.
          </li>
          <li>
            <strong className="text-foreground">Teams scale on shared context.</strong> Swipe
            files, lenses, and templates beat siloed Notion docs every time.
          </li>
          <li>
            <strong className="text-foreground">Security is non-negotiable.</strong> Row-level
            security, account isolation, and explicit roles from day one.
          </li>
        </ul>

        <div className="mt-16 rounded-2xl border border-border bg-card p-8 text-center">
          <h3 className="text-xl font-semibold">Try it yourself</h3>
          <p className="mt-2 text-sm text-muted-foreground">
            Spin up a workspace in under a minute.
          </p>
          <Button asChild className="mt-6">
            <Link to="/signup">Start free trial</Link>
          </Button>
        </div>
      </article>
    </MarketingShell>
  );
}
